export const ColorData = {
  primaryColor: '#8080CF',
  redColor: 'rgb(218,68,51)',
  greenColor: 'rgb(90,196,97)',
  greyColor: '#C4C4C4',
  darkgreyColor: '#8d8d8d'
};

export const titleData = {
  summaryTitle: 'Summary',
  growthDriversTitle: 'Growth Drivers',
  retailerImpact: 'Retailer Impact',
  ownImpact: 'Own Impact',
  potentialUpsidesRisks: 'Potential Upsides & Risks',
  ppgLevelImpact: 'Impact at PPG Level',
  multiyearEstimate: 'Multi-year Estimation',
  metricComparison: 'Metric Comparison'
};

export const chartTypeMap = {
  summaryChart: 'Summary-Chart',
  metricsDifferenceChart: 'Difference-Chart',
  comparisonBarChart: 'Comparison-Chart'
};

export const HoverLabelStyle = {
  align: 'left',
  bgcolor: '#FFF'
};
